<template>
  <v-card class="feed-card">
    <v-row>
      <v-col cols="5">
        <v-img
          class="img ma-auto"
          :src="defaultImage"
        />
      </v-col>
      <v-col cols="7">
        <p>
          <b>NAME: </b>
          <router-link :to="`/dogs/${encodeURIComponent(dogInfo.dogId)}`">{{
            dogInfo.name
          }}</router-link
          ><br />
          <b>DOG ID: </b> {{ dogInfo.dogId }}<br />
          <span v-if="dogInfo.currentUserIsCoowner"><b>CHIP #: </b> {{ dogInfo.chipNumber }}<br /></span>
          <b>GENDER: </b> {{ dogInfo.gender }}<br />
          <b>AGE: </b> {{ dogInfo.age }} years<br />
          <b>BIRTHDAY: </b> {{dogInfo.birthdate ? $dateUtils.formatDate(new Date(dogInfo.birthdate)): ""}} <br />
          <b>SIRE: </b> {{ dogInfo.sire }}<br />
          <b>DAM: </b> {{ dogInfo.dam }}<br />
          <span v-if="dogInfo.currentUserIsCoowner"><b>REGISTRATION #: </b> {{ dogInfo.registrationNumber }}<br /></span>
          <span v-if="dogInfo.currentUserIsCoowner"><b>LITTER #: </b> {{ dogInfo.litterId }}<br /></span>
          <CoownersList
            :owners="dogInfo.owners"
            :ownershipType="dogOwnershipType"
          />
        </p>
      </v-col>
    </v-row>
    <v-row>
        <v-col>
        <router-link
            class="no-text-decoration"
            :to="`/registration/litter/${dogInfo.dogId}`"
        >
            <v-btn
            light
            large
            color="primary"
            width="135px"
            class="mr-5 mt-5"
            v-if="dogInfo.canRegisterLitter"
            >
            Register Litter
            </v-btn>
        </router-link>
        <router-link
            class="no-text-decoration"
            :to="`/leaserequest/${dogInfo.dogId}`"
        >
            <v-btn 
            light
            large
            color="primary"
            width="135px"
            class="mr-5 mt-5"
            v-if="dogInfo.canRegisterLease"> Add Lease </v-btn>
        </router-link>
        </v-col>
    </v-row>
  </v-card>
</template>

<script lang="ts">
import Vue from "vue";
import CoownersList, { OwnershipType } from "@/components/common/CoownersList.vue";
import { UserInfo } from "@/types/User";
import dogService from "@/services/dogService";

const defaultImage = require('@/assets/photouploadblue.png');

export default Vue.extend({
  name: "DogCard",
  data: function () {
    return {
      dogInfo: {} as any,
      defaultImage,
    };
  },
  components: {
    CoownersList,
  },
  props: {
    selectedDog: String,
  },
  created: function () {
    if (this.selectedDog && this.userInfo) {
      dogService
        .getDogById(this.selectedDog, this.userInfo.personId)
        .then((res) => {
          this.dogInfo = res;
        })
        .catch(this.$handleError);
    }
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
    dogOwnershipType: function () {
      return OwnershipType.Dog;
    },
  },
  watch: {
    selectedDog: function (newVal: String) {
      dogService
        .getDogById(this.selectedDog, this.userInfo.personId)
        .then((res) => {
          this.dogInfo = res;
        })
        .catch(this.$handleError);
    },
  },
});
</script>
